<script>
export default {
    name: "AdmissionReport",

    data() {

        return {
            patients: {
                admissionUsers: [],
                wards: [],
                patientAdmissionReport: [],
            }, 
            patstatus: [],
            filter: {
                search: '',
                dateFrom: window.moment().format('YYYY-MM-DD'),
                dateTo: window.moment().format('YYYY-MM-DD'),
                admittedBy: '',
                ward: '',
                special:  '',
            },
        };
    },

    watch: {

        "filter.special"() {
            this.fetchPatients();
        },
    },

    mounted() {

        this.fetchPatients();
        this.fetchPatStatus();
        
    },

    methods: {

        fetchPatients() {
            this.$root.loading = true;
            let url = `PatientsReports/GetAdmssionReport?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
            url += this.filter.admittedBy ? `&AdmittedBy=${this.filter.admittedBy}` : ``;
            url += this.filter.ward ? `&Ward=${this.filter.ward}` : ``;
            //url += `&Special=${this.filter.special}`;
            url += this.filter.special ? `&Special=${this.filter.special}` : ``;
             this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },
        fetchPatStatus() {

return this.$http.get(`Shared/GetPatStatus`).then(response => {
    this.patstatus = response.data;
}).catch(() => {});
},
    
        printAdmissionReport() {

            window.open(`/reports/patients/admission-report/print?page=${this.filter.page}&pageSize=${this.filter.pageSize}&dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}&admittedBy=${this.filter.admittedBy}&ward=${this.filter.ward}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
        printAdmissionNote(patient) {

            window.open(`/outpatient/admission-note/print/${patient.patienT_ID}/${patient.visitNo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Admission Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Admission Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/12 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" id="grid-search" class="input-control input-sm text-xs">
              </div>
               <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model="filter.dateTo" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-admitted-by" class="label-control">Admitted By:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select v-model="filter.admittedBy" id="grid-admitted-by" class="input-control input-sm text-xs">
                              <option value="">Select Admitted By</option>
                              <option v-for="(admittedBy, idx) in patients.admissionUsers" :value="admittedBy" :key="idx">{{ admittedBy }}</option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny">
                  <label for="grid-ward" class="label-control">Ward:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select v-model="filter.ward" id="grid-ward" class="input-control input-sm text-xs">
                              <option value="">Select ward</option>
                              <option v-for="(ward, idx) in patients.wards" :value="ward" :key="idx">{{ ward }}</option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    @click.prevent="fetchPatients" 
                        class="btn-sm btn-info text-xs rounded">
                            <i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-1/12 p-tiny mt-4"  v-if="$root.checkAuth('ViewSpecialPatients')">
                                
                                <tail-select>
                                <template v-slot:field>
                                    <select 
                                        v-model="filter.special"
                                         @change="fetchPatients"
                                        id="grid-consultant" 
                                        class="input-control input-sm text-xs">
                                        <option :value="0">-</option>
                                        <option v-for="stat in patstatus" 
                                            :key="stat.id" 
                                            :value="stat.id">{{ stat.description }}</option>
                                    </select>
                                </template>
                            </tail-select>
                        </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-primary text-xs rounded" @click.prevent="$root.exportToExcel(`patient-admission-report`, `admissionReport`)"><i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    class="btn-sm btn-info text-xs rounded" @click.prevent="printAdmissionReport">
                        <i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="admissionReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/6">Name</th>
                            <th class="p-tiny flex-1">IP NO</th>
                            <th class="p-tiny flex-1">ID NO</th>
                            <th class="p-tiny flex-1">Date</th>
                            <th class="p-tiny flex-1">Time</th>
                            <th class="p-tiny flex-1">User</th>
                            <th class="p-tiny flex-1">Discharged</th>
                            <th class="p-tiny flex-1">Ward</th>
                            <th class="p-tiny flex-1">Bed</th>
                            <th class="p-tiny w-1/6">Diagnosis</th>
                            <th class="p-tiny w-1/6">Payment</th>
                            <th class="p-tiny flex-1">Report</th>
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="flex w-full">
                          <th class="p-tiny w-1/2"></th>
                          <th class="p-tiny w-1/2 text-right">Total Admissions: 
                            {{ patients.patientAdmissionReport ? patients.patientAdmissionReport.length : 0 }}</th>
                      </tr>
                  </tfoot>
                  <tbody 
                    class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                    style="max-height:65vh;">
                      <tr class="flex w-full" v-for="(patient, idx) in patients.patientAdmissionReport" :key="idx">
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipfileno }}</td>
                          <td class="p-tiny flex-1" v-if="$root.checkAuth(`AccessPhoneNo`)">{{ patient.nationalid }}</td>
                          <td class="p-tiny flex-1" v-if="!$root.checkAuth(`AccessPhoneNo`)">{{ patient.maskedNationalID}}</td>
                          <td class="p-tiny flex-1">{{ patient.dateAdmitted | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.timeAdmitted }}</td>
                          <td class="p-tiny flex-1">{{ patient.admittedBy }}</td>
                          <td class="p-tiny flex-1">{{ patient.discharged }}</td>
                          <td class="p-tiny flex-1">{{ patient.ward }}</td>
                          <td class="p-tiny flex-1">{{ patient.bed }}</td>
                          <td class="p-tiny w-1/6">{{ patient.memo }}</td>
                          <td class="p-tiny w-1/6">{{ patient.pMode }}</td>
                          <td class="p-tiny flex-1">
                              <button 
                                @click.prevent="printAdmissionNote(patient)" 
                                class="btn-sm text-xs btn-primary rounded" 
                                title="Preview Admission Note">
                                    <i class="fa fa-print"></i> Note</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>